export const processTreeViewEntities = (entities, dataFilter) => {
  const documents = entities.map((doc) => {
    const isFolder = 'folderType' in doc;

    const pathSegments = isFolder
      ? (doc?.parents || []).map(({ title }) => title)
      : [
          ...(doc.parentFolder?.parents || []).map(({ title }) => title),
          doc.parentFolder?.title,
        ];
    const displayPath = pathSegments.filter((title) => !!title).join('/');
    const fullPath = `${displayPath}${displayPath ? '/' : ''}${doc.title}`;
    const keywords =
      (doc.highlights || []).filter(({ field }) =>
        ['content.name', 'name'].includes(field),
      )[0]?.keywords || [];
    return { ...doc, displayPath, fullPath, highlight: keywords };
  });
  return dataFilter ? dataFilter(documents) : documents;
};
